interface Props {
  /** The same copy the row used to print underneath itself. */
  text: string;
  'data-test'?: string;
}

/**
 * The explanation a settings row used to carry as a paragraph, reduced to a glyph that holds it.
 *
 * No copy is lost — the strings are the ones the `info` props carried; they move from the layout
 * into `title`. Nine rows each printing a paragraph is what made Settings a column of text rather
 * than a column of controls.
 *
 * Rendered as a `span`, not a button: it sits inside rows that are themselves registered keyboard
 * controls, and a nested button would take a second tab stop for something the keyboard cannot
 * usefully act on.
 */
export default function InfoGlyph({ text, 'data-test': dataTest }: Props) {
  return (
    <span
      title={text}
      aria-label={text}
      data-test={dataTest}
      className="flex size-[1.1875rem] shrink-0 cursor-help items-center justify-center rounded-full text-[0.75rem] font-bold text-white/45 shadow-[inset_0_0_0_1px_rgba(255,255,255,.28)]">
      i
    </span>
  );
}
